/**
 * Run a callback once the DOM is parsed, whether or not that already happened.
 *
 * Entry points shipped via `<f:asset.module>` are rendered by TYPO3 as
 * `<script type="module" async>`, so they execute as soon as their module graph
 * has downloaded — which may be before *or* after `DOMContentLoaded` has fired.
 * A bare `document.addEventListener('DOMContentLoaded', …)` therefore silently
 * never runs whenever the module loses that race.
 *
 * Use instead of listening for `DOMContentLoaded` directly.
 */
export function onDomReady(callback: () => void): void {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
        return;
    }

    callback();
}
